export default __webpack_public_path__ + "static/media/fam4.36606ee1.png";